(function () {
  "use strict";

  var CLOSE_MS = 160;

  function openModal(modalEl) {
    if (!modalEl) return;

    modalEl.hidden = false;
    modalEl.classList.remove("modal--is-closing");
    void modalEl.offsetWidth;
    modalEl.classList.add("modal--is-active");
    document.body.classList.add("heylight-modal-open");

    var trigger = document.querySelector(
      ".js-modal-open-heylight-" + modalEl.id.replace("HeyLightModal-", "")
    );
    if (trigger) trigger.setAttribute("aria-expanded", "true");
  }

  function closeModal(modalEl) {
    if (!modalEl || !modalEl.classList.contains("modal--is-active")) return;

    modalEl.classList.add("modal--is-closing");
    modalEl.classList.remove("modal--is-active");

    var trigger = document.querySelector(
      ".js-modal-open-heylight-" + modalEl.id.replace("HeyLightModal-", "")
    );
    if (trigger) trigger.setAttribute("aria-expanded", "false");

    window.setTimeout(function () {
      modalEl.classList.remove("modal--is-closing");
      modalEl.hidden = true;
      if (!document.querySelector(".modal--heylight.modal--is-active")) {
        document.body.classList.remove("heylight-modal-open");
      }
    }, CLOSE_MS);
  }

  function closeActiveHeyLightModal() {
    var activeModal = document.querySelector(
      ".modal--heylight.modal--is-active"
    );
    if (activeModal) closeModal(activeModal);
  }

  function bindOpenTriggers() {
    document.querySelectorAll('[class*="js-modal-open-heylight-"]').forEach(
      function (btn) {
        if (btn.dataset.heylightBound === "true") return;
        btn.dataset.heylightBound = "true";

        btn.addEventListener("click", function (e) {
          e.preventDefault();
          var match = btn.className.match(/js-modal-open-heylight-(\d+)/);
          if (!match) return;
          openModal(document.getElementById("HeyLightModal-" + match[1]));
        });
      }
    );
  }

  function bindCloseControls() {
    document.querySelectorAll(".modal--heylight").forEach(function (modalEl) {
      if (modalEl.dataset.heylightCloseBound === "true") return;
      modalEl.dataset.heylightCloseBound = "true";

      modalEl.querySelectorAll(".js-heylight-modal-close").forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          closeModal(modalEl);
        });
      });
    });
  }

  function setupHeyLightMessageListener() {
    if (window.heylightMessageListener) return;

    window.addEventListener("message", function (e) {
      if (e.data && e.data["heidi-action-toggle-iframe"]) {
        closeActiveHeyLightModal();
      }
    });

    window.heylightMessageListener = true;
  }

  function setupEscapeListener() {
    if (window.heylightEscapeListener) return;

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeActiveHeyLightModal();
    });

    window.heylightEscapeListener = true;
  }

  function boot() {
    bindOpenTriggers();
    bindCloseControls();
    setupHeyLightMessageListener();
    setupEscapeListener();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function () {
    setTimeout(boot, 50);
  });
})();

(function () {
  "use strict";

  var FORM_ID = "NotifyWhenAvailableForm";

  function fieldValue(wrapper, name) {
    var field = wrapper.querySelector('[name="' + name + '"]');
    return field ? (field.value || "").trim() : "";
  }

  function composeBody(wrapper, note) {
    var lines = ["Verfügbarkeitsabfrage"];
    var product = fieldValue(wrapper, "contact[Produkt]");
    var brand = fieldValue(wrapper, "contact[Marke]");
    var sku = fieldValue(wrapper, "contact[Referenz]");
    var url = fieldValue(wrapper, "contact[Produkt-URL]");
    var lastName = fieldValue(wrapper, "contact[Nachname]");
    var title = fieldValue(wrapper, "contact[Anrede]");

    if (product) lines.push("Produkt: " + product);
    if (brand) lines.push("Marke: " + brand);
    if (sku) lines.push("Referenz: " + sku);
    if (url) lines.push("URL: " + url);
    if (title) lines.push("Anrede: " + title);
    if (lastName) lines.push("Nachname: " + lastName);
    if (note) {
      lines.push("");
      lines.push("Bemerkung:");
      lines.push(note);
    }
    return lines.join("\n");
  }

  function upsertHidden(form, name, value) {
    var dest = form.querySelector('[name="' + name + '"]');
    if (!dest) {
      dest = document.createElement("input");
      dest.type = "hidden";
      dest.name = name;
      form.appendChild(dest);
    }
    dest.value = value;
  }

  function validateFields(wrapper) {
    var fields = wrapper.querySelectorAll("input, select, textarea");
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].disabled) continue;
      if (typeof fields[i].checkValidity === "function" && !fields[i].checkValidity()) {
        fields[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  var isSubmitting = false;

  function submitEnquiry(form, wrapper) {
    if (isSubmitting) return;
    if (!validateFields(wrapper)) return;

    var fields = wrapper.querySelectorAll("input, select, textarea");
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var name = field.getAttribute("name");
      if (!name || field.disabled) continue;
      var value = field.value;
      if (name === "contact[body]") {
        value = composeBody(wrapper, (value || "").trim());
      }
      upsertHidden(form, name, value);
      field.disabled = true;
    }

    isSubmitting = true;
    form.submit();
  }

  function showNotifySuccess() {
    var box = document.getElementById("sold-out");
    var success = document.getElementById("notify-form-success-msg");
    var content = document.getElementById("notify-form-content");
    var trigger = document.getElementById("notify-me");

    if (success) success.hidden = false;
    if (content) content.hidden = true;
    if (trigger) trigger.hidden = true;
    if (box) box.classList.add("is-success");
  }

  function bootNotifyForm() {
    var trigger = document.getElementById("notify-me");
    var wrapper = document.getElementById("notify-me-wrapper");
    var form = document.getElementById(FORM_ID);
    var submitBtn = document.querySelector(".notify-me-submit");
    var errors = document.getElementById("notify-form-errors");
    var box = document.getElementById("sold-out");

    if (document.getElementById("notify-form-posted-flag")) {
      showNotifySuccess();
    }

    if (errors && box) {
      box.prepend(errors);
      if (wrapper) {
        wrapper.classList.add("is-open");
        if (trigger) trigger.classList.add("is-open");
      }
    }

    if (trigger && wrapper && trigger.dataset.notifyBound !== "true") {
      trigger.dataset.notifyBound = "true";
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        wrapper.classList.toggle("is-open");
        trigger.classList.toggle("is-open");
      });
    }

    if (submitBtn && form && wrapper && submitBtn.dataset.notifyBound !== "true") {
      submitBtn.dataset.notifyBound = "true";
      submitBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitEnquiry(form, wrapper);
      });
    }

    if (form && wrapper && form.dataset.notifyBound !== "true") {
      form.dataset.notifyBound = "true";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        submitEnquiry(form, wrapper);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootNotifyForm);
  } else {
    bootNotifyForm();
  }

  document.addEventListener("shopify:section:load", bootNotifyForm);
})();
